<template v-if="licenseItem">
  <component
    ref="component"
    :is="componentType"
    :licenseRendererVm="licenseRendererVm"
    :licenseWrapper="licenseWrapper"
    :licenseItem="licenseItem"
    :value="value"
    v-bind="$attrs"
    @input="([fieldName, fieldValue]) => $emit('input', [fieldName, fieldValue])"
  />
</template>

<script>
import LicenseAction from './LicenseAction';
import LicenseContent from './LicenseContent';
import LicenseComponent from './LicenseComponent';

export default {
  components: {
    LicenseAction,
    LicenseContent,
    LicenseComponent,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    licenseWrapper: {
      type: Object,
    },
    licenseItem: {
      type: Object,
    },
    value: {},
  },
  computed: {
    componentType() {
      const licenseItem = this.licenseItem || {};
      const itemType = licenseItem.itemType;

      switch (itemType) {
        case 'action': return LicenseAction;
        case 'content': return LicenseContent;
        case 'component': return LicenseComponent;
        default:
          return licenseItem.component || 'div';
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.component = this.$refs.component;
    });
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/index.vue